import 'css-chunksrc/client/scenes/attachDocuments/filesSystem/path/styles.scss';export default {
  "path": "_path_s6q5u_1",
  "item": "_item_s6q5u_9",
  "project": "_project_s6q5u_22"
};